import TextArea, { TextAreaWrapper as Wrapper } from '@anm/components/form/TextArea';
import styled from 'styled-components';

type TextAreaProps = {
  disabled?: boolean;
};

export const TextAreaWrapper = styled(TextArea)<TextAreaProps>`
  width: 100%;

  ${Wrapper} {
    display: block;
    width: 100%;
    height: auto;
    margin: 7px 0 20px;
    padding: 10px 12px;
    color: #292a2b;
    font-size: 14px;
    line-height: 22px;
    background-color: #f5f7fa;
    border-radius: 5px;
    min-height: 90px;
    border: none;
    resize: none;
    outline: none;
    user-select: none;
    font-family: 'Source Code Pro', monospace;

    &:disabled {
      color: #99a3ad;
      outline: none;
      user-select: none;
      pointer-events: none;
    }
  }
`;

export const LinkWrapper = styled.a.attrs({ target: '_blank' })`
  height: 40px;
  background: #f5f7fa;
  line-height: 40px;
  border: 1px solid #ccdde6;
  border-radius: 5px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
  color: var(--blue_100);
  padding: 0 12px;
  position: relative;

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 12px;
    background: #f5f7fa;
  }
`;
